import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerCPanelComponent } from './customizationPanel';
import { DatePickerModule } from 'primeng/datepicker';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
export interface DatePickerCustomization {
  defaultValue: number;
  topology: number;
  autocompleteRule: boolean;
  required: boolean;
}

@Component({
  selector: 'lib-datepicker-edit',
  imports: [DatePickerCPanelComponent, DatePickerModule, FormsModule],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-datepicker-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div class="flex w-full flex-row">
          <p-datepicker
            [autofocus]="false"
            id="data"
            [ngModel]="widget.customization.defaultValue"
            dateFormat="dd/mm/yy"
            class="w-full"
            appendTo="body"
            [showOnFocus]="false"
            [iconDisplay]="'input'"
            [showIcon]="true"
            #calendar
            [fluid]="true"
            disabled
          />
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class DatePickerComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<DatePickerCustomization>);
}
